module.exports = __webpack_public_path__ + "media/images/emblems/Flag_of_Val_Terbi-e8fea31837ca81b1cf1ec011e39fb51a.png";